import { gql } from '@apollo/client';

export default gql`
  mutation DeleteProvider($input: deleteProviderInput) {
    deleteProvider(input: $input) {
      id
    }
  }
`;
